import * as React from "react";
import { UitkCard, UitkCardLink, UitkCardMedia } from "uitk-react-cards";
import { NativeTileShowcaseModel } from "./typings";
import { UitkFigure } from "uitk-react-images";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { withMabTracker, MabTrackEvent } from "src/components/utility/analytics/MabTracker";
import { LazyLoadedImage } from "src/components/utility/LazyLoadedImage/LazyLoadedImage";

export const MesoNativeTileShowcaseFallback = withMabTracker((props: NativeTileShowcaseModel) => {
  const cardClassName = "font-style uitk-type-heading-500 uitk-type-left";
  const scrimType = UitkScrimType.BOTTOM;
  const rfrr = "native-tile-showcase.In_the Spotlight";

  const { mabTrack } = props;
  const cardClicked = mabTrack
    ? (event: React.SyntheticEvent) => {
        const mabTrackData: MabTrackEvent = {
          moduleName: "in_the_spotlight",
          eventTarget: "in_the_spotlight",
          eventType: "homepageClick.nonPath",
          rfrr,
        };
        mabTrack(mabTrackData);
        event.stopPropagation();
      }
    : undefined;

  return (
    <UitkCard className="horizontal-placeholder">
      <UitkCardMedia className="fallback-card">
        <UitkFigure className="all-image-fit-cover">
          <LazyLoadedImage alt={props.fallbackAltText} src={props.fallbackImage} />
          <UitkScrim type={scrimType}>
            <h3 className={cardClassName}>{props.fallbackHeader}</h3>
            <div className="uitk-type-left uitk-type-paragraph-300 font-style">{props.fallbackCopy}</div>
          </UitkScrim>
        </UitkFigure>
        <UitkCardLink>
          <a
            data-testid="mesoNativeTileShowcaseFallbackLink"
            onClick={cardClicked}
            href={`${props.fallbackClickThru}/?rfrr=${rfrr}`}
          >
            {props.fallbackHeader}
          </a>
        </UitkCardLink>
      </UitkCardMedia>
    </UitkCard>
  );
});
